$(function() {
  $(document).on('click', '#flash_bar .close a', function(e) {
    $('#flash_bar').slideUp();
  });
});
